<h4 class="title-2 mb-4" data-test-id="service-provider-header">Service Provider</h4>

@if (isHhAuthForPacUser) {
  <p-panel
    class="panel-padding mb-4"
    [toggleable]="false"
    header="Agency Preference"
    data-test-id="agency-preference-header"
  >
    <form [formGroup]="agencyPreferenceForm">
      <div class="field">
        <label class="field-required">Does Member have a HH agency preference?</label>
        <div class="p-field-value">
          <div class="flex boolean-radio">
            <p-radioButton 
              formControlName="haveHHAgencyPreference" 
              inputId="yesHaveHHAgencyPreference"
              name="havePreference"
              class="mr-2"
              [value]="true">
            </p-radioButton>
            <label for="yesHaveHHAgencyPreference">Yes</label>
            <p-radioButton 
              formControlName="haveHHAgencyPreference" 
              inputId="noHaveHHAgencyPreference"
              name="havePreference"
              class="mr-2 ml-4"
              [value]="false">
            </p-radioButton>
            <label for="noHaveHHAgencyPreference">No</label>
          </div>
        </div>
      </div>
  
      @if (haveHHAgencyPreference?.value) {
        <div class="field">
          <label class="field-required">Have you confirmed if the HHA will accept member? </label>
          <div class="p-field-value">
            <div class="flex boolean-radio">
              <p-radioButton 
                formControlName="hhaAcceptMember" 
                inputId="yesAcceptMember"
                name="acceptMember"
                class="mr-2"
                [value]="true">
              </p-radioButton>
              <label for="yesAcceptMember">Yes</label>
              <p-radioButton 
                formControlName="hhaAcceptMember" 
                inputId="noAcceptMember"
                name="acceptMember"
                class="mr-2 ml-4"
                [value]="false">
              </p-radioButton>
              <label for="noAcceptMember">No</label>
            </div>
          </div>
        </div>
      } 
      @if (!haveHHAgencyPreference?.value && haveHHAgencyPreference?.value!== null) {
        <p-message severity="secondary" icon="pi pi-info-circle" class="mt-6 mb-4">
          <p class="font-semibold">Carelon will staff Authorization based on member's geographic location:</p>
          <p>Check Dashboard or contact Carelon for staffing update</p>
        </p-message>
      }
    </form>

    @if (haveHHAgencyPreference?.value) {
      <ng-container
        [ngTemplateOutlet]="serviceProviderSearch"
      ></ng-container>
    
      <div class="mt-8">
        <ng-container
        [ngTemplateOutlet]="serviceProviderSelectAddress"
        ></ng-container>
      </div>
    
      <div class="mt-6">
        <ng-container
          [ngTemplateOutlet]="serviceProvider"
        ></ng-container>
      </div>
    }

    @if (isEmptyObj(serviceProviderNote) || (showAddNewProvider && isProviderNotFound)) {
      <app-new-provider-information
        [(serviceProviderNote)]="serviceProviderNote"
        (serviceProviderNoteChange)="handleServiceProviderNoteChange($event)"
      ></app-new-provider-information>
    }
  
    @if (!haveHHAgencyPreference?.value && haveHHAgencyPreference?.value !== null) {
      <ng-container
        [ngTemplateOutlet]="serviceLocationForm"
      ></ng-container>
    }

    @if (haveHHAgencyPreference?.value && (showAddNewProvider || isEmptyObj(serviceProviderNote) || isEmptyObj(provider))) {
      <ng-container
        [ngTemplateOutlet]="serviceLocationForm"
      ></ng-container>
    }

  </p-panel>
} @else {
  @if (provider && !isProviderNotFound && !isSelectViewMode && isExternalUser) {
    <div class="mb-4 font-semibold" data-test-id="service-provider-name-header">
      <span>{{ provider?.providerAccountDTO?.providerName }}</span>
    </div>
  }
  
  <ng-container
    [ngTemplateOutlet]="serviceProviderSearch"
  ></ng-container>
  
  <div class="mt-8">
    <ng-container
    [ngTemplateOutlet]="serviceProviderSelectAddress"
    ></ng-container>
  </div>
  
  <div class="mt-6">
    <ng-container
      [ngTemplateOutlet]="serviceProvider"
    ></ng-container>
  </div>
  
  @if ((provider || isProviderNotFound || npiNotFoundProvider) || !isExternalUser) {
    <ng-container
      [ngTemplateOutlet]="serviceLocationForm"
    ></ng-container>
  }
}


@if (showServProvContinueMessage) {
  <p-panel class="panel-padding" [toggleable]="false" header="Continue to next step"
  >
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        Please click the Next button to proceed.
      </div>
    </div>
  </p-panel>
}

<p-toast position="center"></p-toast>

<!-- Dialogs -->
<p-dialog 
  header="Accepting Care" [(visible)]="displayAcceptingCareQuestion" 
  [modal]="true" appendTo="body" [closable]="false" [resizable]="false" 
  [ngStyle]="{'width': '400px'}" [minY]="70" [maximizable]="false"
  data-test-id="accepting-care-header">
    <p data-test-id="accepting-care-label">Are you accepting care?</p>
    <ng-template #footer>
      <button 
        type="button" pButton icon="pi pi-check"
        (click)="displayAcceptingCareQuestion=false; handleIsAcceptingCareResponse(true)" 
        label="Yes" data-test-id="accepting-care-yes">
      </button>
      <button 
        type="button" pButton icon="pi pi-times"
        (click)="displayAcceptingCareQuestion=false; handleIsAcceptingCareResponse(false)" 
        label="No" class="p-button-secondary" data-test-id="accepting-care-no">
      </button>
    </ng-template>
</p-dialog>

<p-dialog 
  header="Arrange For Another Agency" [(visible)]="displayAnotherAgencyQuestion" 
  [modal]="true" appendTo="body" [closable]="false" [resizable]="false" 
  [ngStyle]="{'width': '400px'}" [minY]="70" [maximizable]="false">
    <p>Have you arranged for another agency?</p>
    <ng-template #footer>
      <button 
        type="button" pButton icon="pi pi-check"
        (click)="displayAnotherAgencyQuestion=false; handleIsAnotherAgencyResponse(true)" 
        label="Yes">
      </button>
      <button type="button" pButton icon="pi pi-times"
        (click)="displayAnotherAgencyQuestion=false; handleIsAnotherAgencyResponse(false)" 
        label="No" class="p-button-secondary">
      </button>
    </ng-template>
</p-dialog>

<ng-template #serviceProviderSearch>
  @if (isSearchViewMode) {
    <app-service-provider-search
      [tenantId]="tenantId"
      [isProviderNotFound]="isProviderNotFound"
      [authRequest]="true"
      [npiNotFound]="npiNotFoundProvider"
      [isHhAuthForPacUser]="isHhAuthForPacUser"
      [(showAddNewProvider)]="showAddNewProvider"
      (npiNotFoundChange)="handleNpiNotFound($event)"
      (isProviderNotFoundChange)="handleProviderNpiNotFound($event)"
      (serviceProviderSelected)="handleServiceProviderSelected($event)">
    </app-service-provider-search>
  }
</ng-template>

<ng-template #serviceProviderSelectAddress>
  @if (providerList?.length && provider === null && isSelectViewMode) {
    <p-panel header="Select a service provider address" data-test-id="service-provider-address">
      <app-service-provider-select-address
        [authRequest]="true"
        [isAcceptingCare]="isAcceptingCare"
        [isExternalUser]="isExternalUser"
        [providers]="providerList"
        (selectionChange)="switchToProviderDetail($event)">
      </app-service-provider-select-address>
    </p-panel>
  }
</ng-template>

<ng-template #serviceProvider>
  @if ((provider && !isSelectViewMode && !isProviderNotFound) || !isExternalUser) {
    <app-service-provider
      [networks]="networks || networkList"
      [provider]="provider"
      [showHistoryTable]="false"
      [networkOption]="networkOptions"
      [manuallySelectedNetworkId]="isManuallySelectedNetwork"
      [isExternalUser]="isExternalUser"
      [tenantName]="tenantName"
      [tenantId]="tenantId"
      [authRequest]="true"
      [isWidgetFirstLevel]="true"
      [isHhAuthForPacUser]="isHhAuthForPacUser"
      (selectedProvider)="handleUpdateProvider($event)"
      (switchProviderView)="handleSwitchViews($event)"
      (manuallySelectedNetworkIdChange)="isManuallySelectedNetworkChange.emit(true)">
    </app-service-provider>
  }
</ng-template>

<ng-template #serviceLocationForm>
  <form [formGroup]="providerServiceLocationForm">
    <p-panel class="panel-padding" [toggleable]="false" header="Enter the service location">
      <div class="p-fluid grid grid-cols-12 gap-4 p-form-widget">
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>Service Address Type:</label>
          <div class="p-field-value">
            <p-select class="forceWidth200"
                      formControlName="serviceAddressType"
                      placeholder="Select"
                      [options]="serviceAddressTypes"
                      (onChange)="loadMemberServiceLocationAddress($event)"
                      appendTo="body">
            </p-select>
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>City:</label>
          <div class="p-field-value">
            <input type="text"
                   class="forceWidth200"
                   pInputText
                   formControlName="serviceCity" />
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>Service Address Location:</label>
          <div class="p-field-value">
            <p-select [options]="serviceAddressLocationTypes"
                      class="forceWidth200"
                      formControlName="serviceAddressLocationType"
                      placeholder="Select"
                      appendTo="body">
            </p-select>
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>State:</label>
          <div class="p-field-value">
            <input type="text"
                   class="forceWidth200"
                   pInputText
                   formControlName="serviceState"
                   readonly />
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>Address 1:</label>
          <div class="p-field-value">
            <input type="text"
                   class="forceWidth200"
                   pInputText
                   formControlName="serviceAddress1" />
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label"><span class="label is-required">*</span>ZIP Code:</label>
          <div class="p-field-value">
            <input type="text"
                   class="forceWidth200"
                   pInputText
                   formControlName="serviceZipcode" />
          </div>
        </div>
        <div class="field col-span-12 md:col-span-6">
          <label class="label">Address 2:</label>
          <div class="p-field-value">
            <input type="text"
                   class="forceWidth200"
                   pInputText
                   formControlName="serviceAddress2" />
          </div>
        </div>
        @if (!isExternalUser) {
          <div class="field col-span-12 md:col-span-6">
            <label class="label">County:</label>
            <div class="p-field-value">
              <input type="text"
                     class="forceWidth200"
                     pInputText
                     formControlName="serviceCounty"
                     readonly />
            </div>
          </div>
        }
      </div>
    </p-panel>
  </form>
</ng-template>